export enum HookType {
  STOP,
  NOTIFICATION,
  PRE_TOOL_USE,
  POST_TOOL_USE,
  USER_PROMPT_SUBMIT,
}

export function hookTypeFrom(value: string | null): HookType | null {
  if (value === null) {
    return null
  }

  switch (value) {
    case 'stop':
      return HookType.STOP
    case 'notification':
      return HookType.NOTIFICATION
    case 'pre-tool-use':
      return HookType.PRE_TOOL_USE
    case 'post-tool-use':
      return HookType.POST_TOOL_USE
    case 'user-prompt-submit':
      return HookType.USER_PROMPT_SUBMIT
    default:
      throw new Error(`Unknown hook type: ${value}`)
  }
}

export function hookTypeToString(type: HookType | null): string {
  if (type === null) {
    return 'NONE'
  }

  switch (type) {
    case HookType.NOTIFICATION:
      return 'NOTIFICATION'
    case HookType.STOP:
      return 'STOP'
    case HookType.PRE_TOOL_USE:
      return 'PRE_TOOL_USE'
    case HookType.POST_TOOL_USE:
      return 'POST_TOOL_USE'
    case HookType.USER_PROMPT_SUBMIT:
      return 'USER_PROMPT_SUBMIT'
    default:
      return `UNKNOWN(${type})`
  }
}

export function resolveHookTypeLabelFor(type: HookType): string {
  switch (type) {
    case HookType.NOTIFICATION:
      return 'Notification'
    case HookType.STOP:
      return 'Stop'
    case HookType.PRE_TOOL_USE:
      return 'Pre Tool Use'
    case HookType.POST_TOOL_USE:
      return 'Post Tool Use'
    case HookType.USER_PROMPT_SUBMIT:
      return 'User Prompt Submit'
    default:
      return 'Unknown'
  }
}
